<template>
  <b-modal id="modal" :title="$t('projects.form.title')" no-close-on-backdrop
           no-close-on-esc
           size="xl"
           @close="onReset()"
  >
    <b-form v-if="data.id" id="form1" autocomplete="off" @reset="onReset" @submit.prevent="onSubmit">


      <b-row>

        <div class="col-12">
          <h3>{{ $t('projects.form.ttl_1') }}</h3>
          <div class="row">
            <div class="col-6 form-group">
              <label>Názov projektu</label>
              <b-form-input v-model="data.name_sk" placeholder="sk"></b-form-input>
            </div>
            <div class="col-6 form-group">
              <label>Projekttitel</label>
              <b-form-input v-model="data.name_de" placeholder="de"></b-form-input>
            </div>
          </div>
        </div>
        <hr class="w-100">
        <div class="col-12">
          <h3>{{ $t('projects.form.ttl_2') }}</h3>
          <div class="row">
            <div class="col-12 form-group">
              <label>2.1. Názov žiadateľa | Name des Antragstellers</label>
              <b-form-input v-model="data.user_name"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>2.2. Adresa žiadateľa (Ulica, č.p., PSČ, obec) | Anschrift des Antragstellers (Strasse, Hausnummer,
                PLZ, Ort)</label>
              <b-form-input v-model="data.user_address"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>2.3. Región a krajina žiadateľa | Region und Land des Antragstellers</label>
              <div class="row">
                <div class="col-12 col-md-7">
                  <b-form-select v-model="data.user_region"
                                 :options="(selectsOptions.region[local] || []).slice(0, -1)"></b-form-select>
                </div>
                <div class="col-12 col-md-5">
                  <b-form-select v-model="data.user_land" :options="selectsOptions.land"></b-form-select>
                </div>
              </div>
            </div>
            <div class="col-12 form-group">
              <label>2.4. Webová stránka | Website</label>
              <b-form-input v-model="data.user_web"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>2.5. IČO/DIČ | ATU/ZVR</label>
              <b-form-input v-model="data.user_ico"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>
                2.6. Bankové spojenie | Bankverbindung
              </label>
              <div class="row mb-3">
                <!--
                  <div class="col-12 col-md-4">
                      <label>{{$t('projects.form.ph_2_4_number')}}</label>
                      <b-form-input v-model="data.user_bank_number" ></b-form-input>
                  </div>
                  <div class="col-12 col-md-2">
                      <label>{{$t('projects.form.ph_2_4_code')}}</label>
                      <b-form-input v-model="data.user_bank_code" ></b-form-input>
                  </div>
                  -->
                <div class="col-12">
                  <label>Názov banky | Name der Bank</label>
                  <b-form-input v-model="data.user_bank_name"></b-form-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_4_iban') }}</label>
                  <b-form-input v-model="data.user_bank_iban"></b-form-input>
                </div>
                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_4_bic_swift') }}</label>
                  <b-form-input v-model="data.user_bank_bic_swift"></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-12 form-group">
              <label>
                2.7. Štatutárny zástupca | Zeichnungsberechtigte Person<br>
              </label>
              <div class="row">
                <div class="col-12 mb-3">
                  <label>{{ $t('projects.form.ph_2_8_contact') }}</label>
                  <b-form-input v-model="data.user_statutor_name"></b-form-input>
                </div>
                <div class="col-6 mb-3">
                  <label>Funkcia</label>
                  <b-form-input v-model="data.user_statutor_function_sk" placeholder="sk"></b-form-input>
                </div>
                <div class="col-6 mb-3">
                  <label>Funktion</label>
                  <b-form-input v-model="data.user_statutor_function_de" placeholder="de"></b-form-input>
                </div>
                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_tel') }}</label>
                  <b-form-input v-model="data.user_statutor_tel"></b-form-input>
                </div>

                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_email') }}</label>
                  <b-form-input v-model="data.user_statutor_email" type="email"></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-12 form-group">
              <label>
                2.8. Kontaktná osoba | Kontaktperson<br>
              </label>
              <div class="row">
                <div class="col-12 mb-3">
                  <label>{{ $t('projects.form.ph_2_8_contact') }}</label>
                  <b-form-input v-model="data.user_contact_name"></b-form-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_tel') }}</label>
                  <b-form-input v-model="data.user_contact_tel"></b-form-input>
                </div>

                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_email') }}</label>
                  <b-form-input v-model="data.user_contact_email" type="email"></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-12 form-group">
              <label>
                2.9. Ďalšie údaje | Sonstige Angaben<br>
              </label>
              <div class="row">
                <div class="col-12 form-group">
                  <b-form-checkbox
                      v-model="data.user_vat"
                      :value="1"
                      class="mt-2"
                  >
                    {{ $t('projects.form.check_2_6_a') }}
                  </b-form-checkbox>

                  <b-form-checkbox
                      v-model="data.user_prev_experience"
                      :value="1"
                      class="mt-2"
                  >
                    {{ $t('projects.form.check_2_6_c') }}
                  </b-form-checkbox>

                  <b-form-checkbox
                      v-model="data.user_advantage"
                      :value="1"
                      class="mt-2"
                  >
                    {{ $t('projects.form.check_2_6_d') }}
                    <!--
                    <span id="popover-2-6-d"><b-icon aria-hidden="true" icon="info-circle"></b-icon></span>
                    <b-popover target="popover-2-6-d" triggers="hover focus">
                      {{ $t('projects.popovers.other_data_4') }}
                    </b-popover>
                    -->
                  </b-form-checkbox>

                  <b-form-checkbox
                      v-model="data.user_flat_rate"
                      :value="1"
                      class="mt-2"
                  >
                    {{ $t('projects.form.check_2_6_e') }}

                  </b-form-checkbox>

                  <p class="mt-2 pl-4" v-if="data.user_flat_rate == 1">{{ $t('projects.form.check_2_6_f') }}</p>
                </div>
                <div class="col-12 col-md-6">
                  <label>
                    Právna forma žiadateľa
                  </label>
                  <b-form-input v-model="data.user_legal_form_sk" placeholder="sk"></b-form-input>
                </div>
                <div class="col-12 col-md-6">
                  <label>
                    Rechtsform des Antragstellers&nbsp;
                  </label>
                  <b-form-input v-model="data.user_legal_form_de" placeholder="de"></b-form-input>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <h3>3.A {{ $t('projects.form.ttl_3') }} 1</h3>
          <div class="row">
            <div class="col-12 form-group">
              <label>3.A.{{ ii = 1 }}. Názov partnera | Name des Projektpartners</label>
              <b-form-input v-model="data.partner_1_name"></b-form-input>
            </div>

            <div class="col-12 form-group">
              <label>3.A.{{ ++ii }}. Adresa partnera (ulica, č., PSČ, obec) | Anschrift des Partners (Strasse,
                Hausnummer, PLZ, Ort)</label>
              <b-form-input v-model="data.partner_1_address"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>3.A.{{ ++ii }}. Región a krajina partnera | Region und Land des Partners</label>
              <div class="row">
                <div class="col-12 col-md-7">
                  <b-form-select v-model="data.partner_1_region" :options="selectsOptions['region'][local]"></b-form-select>
                </div>
                <div class="col-12 col-md-5">
                  <b-form-select v-model="data.partner_1_land" :options="selectsOptions.land"></b-form-select>
                </div>
              </div>
            </div>


            <div class="col-12 form-group">
              <label>3.A.{{ ++ii }}. Webová stránka | Website</label>
              <b-form-input v-model="data.partner_1_web"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>3.A.{{ ++ii }}. IČO/DIČ | ATU/ZVR</label>
              <b-form-input v-model="data.partner_1_ico"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>
                3.A.{{ ++ii }}. Štatutárny zástupca | Zeichnungsberechtigte Person<br>
              </label>
              <div class="row">
                <div class="col-12 mb-3">
                  <label>{{ $t('projects.form.ph_2_8_contact') }}</label>
                  <b-form-input v-model="data.partner_1_statutor_name"></b-form-input>
                </div>
                <div class="col-6 mb-3">
                  <label>Funkcia</label>
                  <b-form-input v-model="data.partner_1_statutor_function_sk" placeholder="sk"></b-form-input>
                </div>
                <div class="col-6 mb-3">
                  <label>Funktion</label>
                  <b-form-input v-model="data.partner_1_statutor_function_de" placeholder="de"></b-form-input>
                </div>
                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_tel') }}</label>
                  <b-form-input v-model="data.partner_1_statutor_tel"></b-form-input>
                </div>

                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_email') }}</label>
                  <b-form-input v-model="data.partner_1_statutor_email" type="email"></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-12 form-group">
              <label>
                3.A.{{ ++ii }}. Kontaktná osoba | Kontaktperson<br>
              </label>
              <div class="row">
                <div class="col-12 mb-3">
                  <label>{{ $t('projects.form.ph_2_5_contact') }}</label>
                  <b-form-input v-model="data.partner_1_contact_name"></b-form-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_tel') }}</label>
                  <b-form-input v-model="data.partner_1_contact_tel"></b-form-input>
                </div>

                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_email') }}</label>
                  <b-form-input v-model="data.partner_1_contact_email" type="email"></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-12 form-group">
              <label>
                3.A.{{ ++ii }}. Ďalšie údaje | Sonstige Angaben<br>
              </label>
              <div class="row">
                <div class="col-12 form-group">

                  <b-form-checkbox
                      v-model="data.partner_1_prev_experience"
                      :value="1"
                      class="mt-2"
                  >
                    {{ $t('projects.form.check_3_7_experience_crossborder') }}
                  </b-form-checkbox>
                  <b-form-checkbox
                      v-model="data.partner_1_own_application"
                      :value="1"
                      class="mt-2"
                  >
                    {{ $t('projects.form.check_3_7_own_application') }}
                  </b-form-checkbox>

                </div>
                <div class="col-12 col-md-6">
                  <label>
                    Právna forma partnera
                  </label>
                  <b-form-input v-model="data.partner_1_legal_form_sk" placeholder="sk"></b-form-input>
                </div>
                <div class="col-12 col-md-6">
                  <label>
                    Rechtsform des Partners
                  </label>
                  <b-form-input v-model="data.partner_1_legal_form_de" placeholder="de"></b-form-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <b-button v-if="partnerBlock_2 == false && data.partner_2_name == ''" @click="partnerBlock_2 = true"
                    type="button" size="sm" variant="primary">
            <b-icon class="clickable" icon="plus-square-fill" variant=""></b-icon>&nbsp;
            {{ $t('projects.form.showPartner2') }}

          </b-button>
          <b-button v-else @click="removePartner2" type="button" size="sm" variant="danger">
            <b-icon class="clickable" icon="trash-fill" variant=""></b-icon>&nbsp;
            {{ $t('projects.form.removePartner2') }}
          </b-button>
        </div>
        <div v-if="partnerBlock_2 || data.partner_2_name != '' " class="col-12">
          <h3>3.B {{ $t('projects.form.ttl_3') }} 2</h3>
          <div class="row">
            <div class="col-12 form-group">
              <label>3.B.{{ ii = 1 }}. Názov partnera | Name des Projektpartners</label>
              <b-form-input v-model="data.partner_2_name"></b-form-input>
            </div>

            <div class="col-12 form-group">
              <label>3.B.{{ ++ii }}. Adresa partnera (ulica, č., PSČ, obec) | Anschrift des Partners (Strasse,
                Hausnummer, PLZ, Ort)</label>
              <b-form-input v-model="data.partner_2_address"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>3.B.{{ ++ii }}. Región a krajina partnera | Region und Land des Partners</label>
              <div class="row">
                <div class="col-12 col-md-7">
                  <b-form-select v-model="data.partner_2_region" :options="selectsOptions['region'][local]"></b-form-select>
                </div>
                <div class="col-12 col-md-5">
                  <b-form-select v-model="data.partner_2_land" :options="selectsOptions.land"></b-form-select>
                </div>
              </div>
            </div>

            <div class="col-12 form-group">
              <label>3.B.{{ ++ii }}. Webová stránka | Website</label>
              <b-form-input v-model="data.partner_2_web"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>3.B.{{ ++ii }}. IČO/DIČ | ATU/ZVR</label>
              <b-form-input v-model="data.partner_2_ico"></b-form-input>
            </div>
            <div class="col-12 form-group">
              <label>
                3.B.{{ ++ii }}. Štatutárny zástupca | Zeichnungsberechtigte Person<br>
              </label>
              <div class="row">
                <div class="col-12 mb-3">
                  <label>{{ $t('projects.form.ph_2_8_contact') }}</label>
                  <b-form-input v-model="data.partner_2_statutor_name"></b-form-input>
                </div>
                <div class="col-6 mb-3">
                  <label>Funkcia</label>
                  <b-form-input v-model="data.partner_2_statutor_function_sk" placeholder="sk"></b-form-input>
                </div>
                <div class="col-6 mb-3">
                  <label>Funktion</label>
                  <b-form-input v-model="data.partner_2_statutor_function_de" placeholder="de"></b-form-input>
                </div>
                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_tel') }}</label>
                  <b-form-input v-model="data.partner_2_statutor_tel"></b-form-input>
                </div>

                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_email') }}</label>
                  <b-form-input v-model="data.partner_2_statutor_email" type="email"></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-12 form-group">
              <label>
                3.B.{{ ++ii }}. Kontaktná osoba | Kontaktperson<br>
              </label>
              <div class="row">
                <div class="col-12 mb-3">
                  <label>{{ $t('projects.form.ph_2_5_contact') }}</label>
                  <b-form-input v-model="data.partner_2_contact_name"></b-form-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_tel') }}</label>
                  <b-form-input v-model="data.partner_2_contact_tel"></b-form-input>
                </div>

                <div class="col-12 col-md-6">
                  <label>{{ $t('projects.form.ph_2_5_email') }}</label>
                  <b-form-input v-model="data.partner_2_contact_email" type="email"></b-form-input>
                </div>
              </div>
            </div>
            <div class="col-12 form-group">
              <label>
                3.B.{{ ++ii }}. Ďalšie údaje | Sonstige Angaben<br>
              </label>
              <div class="row">
                <div class="col-12 form-group">

                  <b-form-checkbox
                      v-model="data.partner_2_prev_experience"
                      :value="1"
                      class="mt-2"
                  >
                    {{ $t('projects.form.check_3_7_experience_crossborder') }}
                  </b-form-checkbox>
                  <b-form-checkbox
                      v-model="data.partner_2_own_application"
                      :value="1"
                      class="mt-2"
                  >
                    {{ $t('projects.form.check_3_7_own_application') }}
                  </b-form-checkbox>

                </div>
                <div class="col-12 col-md-6">
                  <label>
                    Právna forma partnera
                  </label>
                  <b-form-input v-model="data.partner_2_legal_form_sk" placeholder="sk"></b-form-input>
                </div>
                <div class="col-12 col-md-6">
                  <label>
                    Rechtsform des Partners
                  </label>
                  <b-form-input v-model="data.partner_2_legal_form_de" placeholder="de"></b-form-input>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr class="w-100">
        <div class="col-12">
          <h3>4. {{ $t('projects.form.ttl_4') }}</h3>
          <div class="row">
            <div class="col-6 form-group">
              <label>4.1. Skratka názvu projektu</label>
              <b-form-input v-model="data.name_shortcut_sk" placeholder="sk"></b-form-input>
            </div>
            <div class="col-6 form-group">
              <label>4.1. Kurzprojekttitel</label>
              <b-form-input v-model="data.name_shortcut_de" placeholder="de"></b-form-input>
            </div>
            <div class="col-12">
              <label>4.2. {{ $t('projects.form.project_duration') }}</label>
            </div>
            <div class="col-12 form-group">
              <label>
                {{ $t('projects.form.scheduledStart') }}<br>
              </label>
              <b-input v-model="data.project_start" type="date" :min="settings.date" class="mb-2"></b-input>
            </div>
            <div class="col-12 form-group">
              <label v-html="$t('projects.form.scheduledEnd')">
              </label>
              <b-input v-model="data.project_end" type="date" class="mb-2"></b-input>
            </div>

            <div class="col-6">
              <label>4.3. Popis projektu</label>
            </div>
            <div class="col-6">
              <label>4.3. Beschreibung des Projektes</label>
            </div>

            <div class="col-6 form-group">
              <label>4.3.1 Ciele projektu a potreba projektu<br>
                <small>Opíšte, aké konkrétne cezhraničné ciele projekt sleduje. Opíšte, akým spôsobom projekt prispeje k dosiahnutiu Špecifického cieľa 4.2 Programu Interreg „Budovanie vzájomnej dôvery, predovšetkým propagáciou akcií „ľudia ľuďom“. (max. 1000 znakov)</small>
              </label>
              <b-textarea v-model="data.project_goals_sk" max-rows="8" rows="2" placeholder="sk"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>4.3.1 Projektziele und Projektbedarf<br>
                <small>Beschreiben Sie, welche konkreten grenzüberschreitenden Ziele das Projekt verfolgt und erklären Sie, welchen Beitrag das Projekt zur Erreichung des spezifischen Ziels 4.2 des Interreg-Programms „Aufbau von gegenseitigem Vertrauen, insbesondere durch Förderung von Menschen-zu-Menschen-Aktionen“ leisten wird. (max. 1300 Zeichen)</small>
              </label>
              <b-textarea v-model="data.project_goals_de" max-rows="8" rows="2" placeholder="de"></b-textarea>
            </div>

            <div class="col-6 form-group">
              <label>4.3.2 Obsah a aktivity projektu<br>
                <small>Podrobne popíšte aktivity, ktoré sú obsahom projektu. Príklady podporovaných aktivít nájdete v Príručke pre Fond malých projektov. (max. 2000 znakov)</small>
              </label>
              <b-textarea v-model="data.project_description_sk" max-rows="8" rows="2" placeholder="sk"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>4.3.2 Projektinhalt und Projektaktivitäten<br>
                <small>Beschreiben Sie die im Projekt enthaltenen Aktivitäten im Detail. Beispiele für geförderte Aktivitäten finden Sie im Handbuch für den Kleinprojektfonds. (max. 2500 Zeichen)</small>
              </label>
              <b-textarea v-model="data.project_description_de" max-rows="8" rows="2" placeholder="de"></b-textarea>
            </div>

            <div class="col-6 form-group">
              <label>4.3.3 Cieľové skupiny<br>
                <small>Popíšte zapojenie cieľových skupín v rámci plánovaných aktivít a komunikáciu s nimi. Ako zabezpečíte viditeľnosť a propagáciu projektu, ako konkrétne budete informovať verejnosť a cieľové skupiny o aktivitách projektu? Vyčíslite koľko účastníkov je plánované zapojiť zo Slovenska a koľko z Rakúska. (max. 900 znakov)</small>
              </label>
              <b-textarea v-model="data.project_target_groups_sk" max-rows="8" rows="2" placeholder="sk"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>4.3.3 Zielgruppen<br>
                <small>Beschreiben Sie die Einbindung der Zielgruppen im Rahmen der geplanten Aktivitäten und die Kommunikation mit ihnen. Wie stellen Sie die Sichtbarkeit und Propagation des Projekts sicher, wie genau werden Sie die Öffentlichkeit und die Zielgruppen über die Aktivitäten des Projekts informieren? Geben Sie an, wie viele Teilnehmer aus der Slowakei und wie viele aus Österreich voraussichtlich eingebunden werden. (max. 1200 Zeichen)</small>
              </label>
              <b-textarea v-model="data.project_target_groups_de" max-rows="8" rows="2" placeholder="de"></b-textarea>
            </div>

            <div class="col-6 form-group">
              <label>4.3.4 Cezhraničný dopad projektu<br>
                <small>Vysvetlite nevyhnutnosť a pozitívny vplyv cezhraničnej spolupráce pre realizáciu projektu. Ako prispieva projekt k odstraňovaniu prekážok a/alebo vytvoreniu spoločných štruktúr v regióne? (max. 900 znakov)</small></label>
              <b-textarea v-model="data.project_crossborder_impact_sk" max-rows="8" rows="2" placeholder="sk"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>4.3.4 Grenzüberschreitende Wirkung<br>
                <small>Erklären Sie die Notwendigkeit und die positive Wirkung der grenzüberschreitenden Zusammenarbeit für die Durchführung des Projekts. Wie trägt das Projekt zur Beseitigung von Barrieren und/oder zum Aufbau gemeinsamer Strukturen in der Region bei? (max. 1200 Zeichen)</small></label>
              <b-textarea v-model="data.project_crossborder_impact_de" max-rows="8" rows="2" placeholder="de"></b-textarea>
            </div>

            <div class="col-6 form-group">
              <label>4.3.5 Udržateľnosť projektu<br>
                <small>Ako sa budú výstupy projektu udržiavať a používať po ukončení jeho realizácie? Budú partneri spolupracovať aj po ukončení projektu? (max. 500 znakov)</small></label>
              <b-textarea v-model="data.project_sustainability_sk" max-rows="8" rows="2" placeholder="sk"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>4.3.5 Dauerhaftigkeit des Projektes<br>
                <small>Wie werden die Projektergebnisse nach Abschluss des Projekts beibehalten und genutzt? Werden die Partner auch nach dem Projektabschluss weiter zusammenarbeiten? (max. 700 Zeichen)</small></label>
              <b-textarea v-model="data.project_sustainability_de" max-rows="8" rows="2" placeholder="de"></b-textarea>
            </div>

            <div class="col-6">
              <label>4.3.6 Územný dopad projektu<br>
              <small>Opíšte, na akú územnú oblasť bude mať projekt vplyv a v ktorých okresoch, mestách alebo obciach sa budú konkrétne projektové aktivity realizovať.</small></label>
            </div>
            <div class="col-6">
              <label>4.3.6 Räumlicher Wirkungsbereich des Projektes<br>
              <small>Beschreiben Sie auf welches räumliche Gebiet das Projekt Auswirkung haben wird und genau, in welchen Bezirken, Städten bzw. Gemeinden die konkreten Projektaktivitäten stattfinden werden.
              </small></label>
            </div>

            <div class="col-6">
              <label>Slovensko</label>
              <b-textarea v-model="data.project_impact_cz_sk" class="mb-2" placeholder="sk" max-rows="8" rows="2"></b-textarea>
            </div>
            <div class="col-6">
              <label>Slowakei</label>
              <b-textarea v-model="data.project_impact_cz_de" class="mb-2" placeholder="de" max-rows="8" rows="2"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>Rakúsko</label>
              <b-textarea v-model="data.project_impact_at_sk" max-rows="8" placeholder="sk" rows="2"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>Österreich</label>
              <b-textarea v-model="data.project_impact_at_de" max-rows="8" placeholder="de" rows="2"></b-textarea>
            </div>
            <!--
              <div class="col-12 form-group">
                <label>4.3.7 Typové aktivity projektu - vyplňují jen čeští žadatelé | Aktivitätstypen - nur für tschechische Antragsteller
                </label>
                <div class="row">
                  <project-activities :type="0" ref="project_activities" :id-article="data.id"></project-activities>
                </div>

              </div>
            -->
            <div class="col-12 form-group">
              <label>4.3.7 Míľniky projektu | Projektmeilensteine
              </label>
              <div class="row">
                <project-activities :type="1" ref="project_activities_2" :id-article="data.id"></project-activities>
              </div>

            </div>
            <div class="col-12">
              <label>4.4. {{ $t('projects.form.project_result') }}<br><small>{{ $t('projects.form.project_result_small') }}</small>
                <!--
                <span id="popover-4_2"><b-icon aria-hidden="true" icon="info-circle"></b-icon></span>
                -->
              </label>
              <b-popover target="popover-4_2" triggers="hover focus">
                {{ $t('projects.popovers.results') }}
              </b-popover>
            </div>
            <template>
              <!-- Group -->
              <div class="col-12 form-group">
                <label>{{ $t('projects.results.rco_81') }}<br><small>{{ $t('projects.results.rco_81_small') }}</small></label>
                <b-form-input v-model="data.rco_81" type="number" min="0"></b-form-input>
              </div>
              <template v-if="data.rco_81 > 0">
                <div class="col-6 form-group">
                  <label>Opis cieľovej hodnoty (max. 600 znakov) - RCO 81</label>
                  <b-textarea v-model="data.text_rco_81" placeholder="sk" max-rows="8" rows="2"></b-textarea>
                </div>
                <div v-if="data.rco_81 > 0" class="col-6 form-group">
                  <label>Beschreibung des Zielwertes (max. 700 Zeichen) - RCO 81</label>
                  <b-textarea v-model="data.text_rco_81_de" placeholder="de" max-rows="8" rows="2"></b-textarea>
                </div>
              </template>
              <template v-if="data.rco_81 > 0">
                <div v-if="data.rco_81 > 0" class="col-12 form-group">
                  <label class="color-blue">{{ $t('projects.results.rcr_85') }}<br><small>{{ $t('projects.results.rcr_85_small') }}</small></label>
                  <b-form-input v-model="data.rcr_85_81" type="number" min="0"></b-form-input>
                </div>
                <div v-if="data.rcr_85_81 > 0" class="col-6 form-group">
                  <label class="color-blue">Opis cieľovej hodnoty (max. 600 znakov) - RCR 85</label>
                  <b-textarea v-model="data.text_rcr_85_81" placeholder="sk" max-rows="8" rows="2"></b-textarea>
                </div>
                <div v-if="data.rcr_85_81 > 0" class="col-6 form-group">
                  <label class="color-blue">Beschreibung des Zielwertes (max. 700 Zeichen) - RCR 85</label>
                  <b-textarea v-model="data.text_rcr_85_81_de" placeholder="de" max-rows="8" rows="2"></b-textarea>
                </div>
              </template>
              <!-- END Group -->
              <hr class="w-100">
              <!-- Group -->
              <div class="col-12 form-group">
                <label>{{ $t('projects.results.rco_115') }}<br><small>{{ $t('projects.results.rco_115_small') }}</small></label>
                <b-form-input v-model="data.rco_115" type="number" min="0"></b-form-input>
              </div>
              <template v-if="data.rco_115 > 0">
                <div class="col-6 form-group">
                  <label>Opis cieľovej hodnoty (max. 600 znakov) - RCO 115</label>
                  <b-textarea v-model="data.text_rco_115" placeholder="sk" max-rows="8" rows="2"></b-textarea>
                </div>
                <div v-if="data.rco_115 > 0" class="col-6 form-group">
                  <label>Beschreibung des Zielwertes (max. 700 Zeichen) - RCO 115</label>
                  <b-textarea v-model="data.text_rco_115_de" placeholder="de" max-rows="8" rows="2"></b-textarea>
                </div>
              </template>
              <template v-if="data.rco_115 > 0">
                <div v-if="data.rco_115 > 0" class="col-12 form-group">
                  <label class="color-blue">{{ $t('projects.results.rcr_85') }}<br><small>{{ $t('projects.results.rcr_85_small') }}</small></label>
                  <b-form-input v-model="data.rcr_85_115" type="number" min="0"></b-form-input>
                </div>
                <div v-if="data.rcr_85_115 > 0" class="col-6 form-group">
                  <label class="color-blue">Komentovanie cieľovej hodnoty (max. 600 znakov) - RCR 85</label>
                  <b-textarea v-model="data.text_rcr_85_115" placeholder="sk" max-rows="8" rows="2"></b-textarea>
                </div>
                <div v-if="data.rcr_85_115 > 0" class="col-6 form-group">
                  <label class="color-blue">Beschreibung des Zielwertes (max. 700 Zeichen) - RCR 85</label>
                  <b-textarea v-model="data.text_rcr_85_115_de" placeholder="de" max-rows="8" rows="2"></b-textarea>
                </div>
              </template>
              <!-- END Group -->
              <hr class="w-100">
            </template>
          </div>
        </div>
        <div class="col-12">
          <h3>5. {{ $t('projects.form.ttl_5') }}
            <!--
            <small id="popover-5">
              <b-icon aria-hidden="true" icon="info-circle"></b-icon>
            </small>
            <b-popover target="popover-5" triggers="hover focus">
              {{ $t('projects.popovers.cross_border') }}
            </b-popover>
            -->
          </h3>
          <div class="row">
            <div class="col-6 form-group">
              <label>5.1. Spoločná príprava projektu
                <small>(max. 500 znakov)</small>
              </label>
              <b-textarea v-model="data.quality_common_preparation_sk" placeholder="sk" max-rows="8" rows="2"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>5.1. Gemeinsame Vorbereitung
                <small>(max. 650 Zeichen)</small>
              </label>
              <b-textarea v-model="data.quality_common_preparation_de" placeholder="de" max-rows="8" rows="2"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>5.2. Spoločná realizácia projektu a rozdelenie úloh medzi partnermi
                <small>(max. 500 znakov)</small>
              </label>
              <b-textarea v-model="data.quality_joint_realization_sk" placeholder="sk" max-rows="8" rows="2"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>5.2. Gemeinsame Umsetzung und Aufgabenteilung zwischen den Partnern
                <small>(max. 650 Zeichen)</small>
              </label>
              <b-textarea v-model="data.quality_joint_realization_de" placeholder="de" max-rows="8" rows="2"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>5.3. Spoločné financovanie</label>
              <b-form-checkbox
                  v-model="data.quality_joint_financing_checkbox"
                  @change="calcFinancePartner()"
                  :value="1"
              > ANO
              </b-form-checkbox>
              <label v-if="data.quality_joint_financing_checkbox">Popis (max. 500 znakov)<br><small>Rozpočet partnera musí predstavovať minimálne 5 % celkového rozpočtu projektu. Uveďte, akou sumou sa partnerská organizácia podieľa na financovaní.</small></label>
              <b-textarea v-if="data.quality_joint_financing_checkbox"
                          v-model="data.quality_joint_financing_sk"
                          placeholder="sk"
                          max-rows="8" rows="2"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>5.3. Gemeinsame Finanzierung</label>
              <b-form-checkbox
                  v-model="data.quality_joint_financing_checkbox"
                  @change="calcFinancePartner()"
                  :value="1"
              > JA
              </b-form-checkbox>
              <label v-if="data.quality_joint_financing_checkbox">Beschreibung (max. 650 Zeichen)<br><small>Das Budget des Partners muss mindestens 5 % des Gesamtbudgets des Projekts betragen. Bitte geben Sie an, mit welchem Betrag sich die Partnerorganisation an der Finanzierung beteiligt. </small></label>
              <b-textarea v-if="data.quality_joint_financing_checkbox"
                          v-model="data.quality_joint_financing_de"
                          placeholder="de"
                          max-rows="8" rows="2"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>5.4. Spoločný personál</label>
              <b-form-checkbox
                  v-model="data.quality_common_staff_checkbox"
                  :value="1"
              > ANO
              </b-form-checkbox>
              <label v-if="data.quality_common_staff_checkbox">Popis (max. 500 znakov)</label>
              <b-textarea v-if="data.quality_common_staff_checkbox"
                          v-model="data.quality_common_staff_sk"
                          placeholder="sk"
                          max-rows="8" rows="2"></b-textarea>
            </div>
            <div class="col-6 form-group">
              <label>5.4. Gemeinsames Personal</label>
              <b-form-checkbox
                  v-model="data.quality_common_staff_checkbox"
                  :value="1"
              > JA
              </b-form-checkbox>
              <label v-if="data.quality_common_staff_checkbox">Beschreibung (max. 650 Zeichen)</label>
              <b-textarea v-if="data.quality_common_staff_checkbox"
                          v-model="data.quality_common_staff_de"
                          placeholder="de"
                          max-rows="8" rows="2"></b-textarea>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex w-100 justify-content-between">
            <h3>6. {{ $t('projects.form.ttl_6') }}</h3>
            <b>{{ $t('projects.form.finance_amount') }}</b>
          </div>

          <div class="row">
            <div class="col-12 form-group">
              <div class="row mb-2">
                <div class="col-7">
                  <b>{{ $t('projects.form.total_budget') }}</b>
                </div>
                <div class="col-5">
                  <b-form-input v-model="data.unit_cost" step="0.01" type="number" :value="0" hidden=""></b-form-input>
                  <b-form-input v-model="data.budget_draft" step="0.01" type="number"
                                @input="calcFinance()"></b-form-input>
                </div>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-12 form-group">
              <div class="row mb-2">
                <div class="col-7">
                  <b>{{ $t('projects.form.finance_resources') }}</b>
                </div>
                <div class="col-2 text-right">
                  <b>{{ $t('projects.form.finance_percent') }}</b>
                </div>
                <div class="col-3 text-right">
                  <b>{{ $t('projects.form.finance_amount') }}</b>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-7">
                  {{ $t('projects.form.finance_2') }}
                </div>
                <div class="col-2 text-right">
                  <b-form-input v-model="data.finance_from_efrr_percent" step="1" max="80" @input="calcFinance()"
                                type="number"></b-form-input>
                </div>
                <div class="col-3">
                  <b-form-input :value="data.finance_from_efrr.toFixed(2)" type="number" readonly></b-form-input>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-7">
                  {{ $t('projects.form.finance_3') }}
                </div>
                <div class="col-2 text-right">
                  <b-form-input :value="(100 - data.finance_from_efrr_percent).toFixed(2)" type="number"
                                readonly=""></b-form-input>
                </div>
                <div class="col-3">
                  <b-form-input :value="(data.finance_from_contributor)" type="number" readonly></b-form-input>
                </div>
              </div>
<!--
              <div class="row mb-2">
                <div class="col-12">
                  <b>{{ $t('projects.form.finance_contribution') }}</b>
                </div>
              </div>

              <div class="row mb-2">
                  <div class="col-7">
                      {{$t('projects.form.finance_contribution_1')}}
                  </div>
                  <div class="col-2">
                      <b-form-input v-model="data.finance_other_sources_percent" step="0.01" type="number" :title="$t('projects.form.finance_percent')"></b-form-input>
                  </div>
                  <div class="col-3">
                      <b-form-input v-model="data.finance_other_sources_amount" step="0.01" type="number" :title="$t('projects.form.finance_amount')"></b-form-input>
                  </div>
              </div>
              <div class="row mb-2" v-if="data.quality_joint_financing_checkbox">
                <div class="col-7">
                  {{ $t('projects.form.finance_contribution_2') }}
                  <b-badge pill variant="warning"
                           v-if="(limitPercent).toFixed(2) > Number(data.finance_partner_sources_amount).toFixed(2)">
                    {{ $t('projects.form.finance_contribution_2_max_warning') }}
                  </b-badge>
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                  <b-form-input v-model="data.finance_partner_sources_amount"
                                step="0.01"
                                type="number"
                                :min="limitPercent.toFixed(2)"
                                :title="$t('projects.form.finance_amount')"
                                @input="calcFinancePartner('finance_partner_sources_amount')"
                  ></b-form-input>
                </div>
              </div>
              -->
            </div>

            <div class="col-12 form-group">
              <label>
                Povinné prílohy k žiadosti o projekt | Verpflichtende Anhänge zum Projektantrag
                <!--<span id="popover-attachment"><b-icon aria-hidden="true" icon="info-circle"></b-icon></span>-->
                <b-popover target="popover-attachment" triggers="hover focus">
                  {{ $t('projects.popovers.attachment') }}
                </b-popover>
                <br>
              </label>
              <div class="row">
                <div class="col-12 form-group">
                  <template v-for="(item, key) in ['0a', '0', '1a', '1', '2', '3', '4', '5', '6']">
                    <b-form-checkbox :key="key" v-model="data['at_' + (item)]" value="1">
                      <span v-html="$t('projects.attachment_items.at_' + (item))"></span>
                    </b-form-checkbox>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>

      <div v-if="data.status == ''" class="form-group">
        <b-button variant="danger" @click="deleteItem(data.id)">{{ $t('projects.form.deleteProject') }}
          <b-icon icon="trash-fill"></b-icon>
        </b-button>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button class="float-left" form="form1" type="reset" variant="outline-secondary">
          {{ $t('universalTxt.closeBtn') }}
        </b-button>
        <b-button class="float-right" form="form1" type="submit" variant="primary">
          {{ $t('universalTxt.saveBtn') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import ProjectActivities from "../../components/project-activities.vue";

export default {
  name: "projects-edit",
  components: {ProjectActivities},
  data() {
    return {
      id: parseInt(this.$route.params.id),
      data: {},
      settings: {},
      data_activities: {},
      autoSaveInterval: null,
      partnerBlock_2: false
    }
  },
  methods: {

    removePartner2() {
      this.partnerBlock_2 = false;
      this.data.partner_2_name = '';
    },

    async loadData() {
      try {
        const response = await this.$http({
          url: process.env.VUE_APP_SERVER + 'api/articles/list.php',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          params: {'id': this.id},
          method: 'GET'
        });

        this.data = response.data[0];

      } catch (error) {
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }

    },

    async loadDataSettings() {
      try {
        const response = await this.$http({
          url: process.env.VUE_APP_SERVER + 'api/settings/list.php',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          params: {'id': 1},
          method: 'GET'
        });

        this.settings = response.data.records;

      } catch (error) {
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }

    },

    async saveData() {
      try {
        await this.$refs.project_activities?.updateItems();
        await this.$refs.project_activities_2?.updateItems();
        await this.$http({
          url: process.env.VUE_APP_SERVER + 'api/articles/update-item.php',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: this.data,
          method: 'PUT'
        });

        this.$eventHub.$emit('openMessageController', 'success', this.$t('messages.success'));
      } catch (error) {
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }
    },
    async onSubmit() {
      await this.saveData();
      this.$emit('loadData');
      this.$router.go(-1);
    },

    async deleteItem(id) {
      try {
        if (confirm(this.$t('projects.deleteItem'))) {
          await this.$http({
            url: process.env.VUE_APP_SERVER + 'api/articles/remove-item.php',
            headers: {'content-type': 'application/x-www-form-urlencoded'},
            data: {'id': id},
            method: 'DELETE'
          });
          this.$emit('loadData');
          this.$bvModal.hide('modal');
          this.$router.go(-1);
          this.$eventHub.$emit('openMessageController', 'success', this.$t('messages.deleted'));
        }

      } catch (error) {
        await this.loadData();
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }

    },
    onReset() {
      this.$emit('loadData');
      this.$router.go(-1);
    },
    calcFinance: function () {

      this.data.finance_total_expenses = (Number(this.data.budget_draft) + Number(this.data.budget_unit_cost));
      this.data.finance_from_efrr = Math.floor(((this.data.finance_total_expenses) * (this.data.finance_from_efrr_percent / 100)) * 100) / 100;
      this.data.finance_from_contributor = Math.ceil(((this.data.finance_total_expenses) * ((100 - this.data.finance_from_efrr_percent) / 100)) * 100) / 100;

      this.calcFinancePartner();
    },
    calcFinancePartner: function (type = null) {

      if (type !== 'finance_partner_sources_amount') {
        if (!this.data.quality_joint_financing_checkbox) {
          this.data.finance_partner_sources_amount = 0;

        } else {

          if ((this.data.finance_partner_sources_amount < (Math.ceil((this.data.finance_total_expenses) * 0.05 * 100) / 100)) ||
              this.data.finance_partner_sources_amount > (this.data.finance_total_expenses)) {
            this.data.finance_partner_sources_amount = ((Math.ceil((this.data.finance_total_expenses) * 0.05 * 100) / 100)).toFixed(2);
          }

        }
      }

      this.data.finance_own_sources_amount = (((this.data.finance_from_contributor)) - this.data.finance_partner_sources_amount).toFixed(2);

    }

  },
  computed: {
    local: function () { return this.$store.getters.local },
    selectsOptions: function () {
      return {
        region: this.$store.getters.regions,
        land: ['AT', 'SK']
      }
    },
    permissionsOptions: function () {
      return this.$store.getters.getUserRoles;
    },
    languages() {
      return this.$store.getters.langs
    },
    limitPercent: function () {
      return (Math.ceil(((this.data.finance_total_expenses) * 0.05) * 100) / 100);
    }
  },
  watch: {
    /*
    'data.budget_unit_cost': function() {
      this.calcFinance();
    },
    'data.budget_draft': function() {
      this.calcFinance();
    },
    'data.finance_from_efrr_percent': function() {
      this.calcFinance();
    },


    'data.finance_own_sources_amount': function() {
      this.calcFinancePartner();
    }

   */
  },
  mounted() {
    this.$bvModal.show('modal');
    this.loadData();
    this.loadDataSettings();

    /*
    this.autoSaveInterval = setInterval(() => {
      try {
        this.saveData();
        this.$eventHub.$emit('openMessageController', 'success', this.$t('messages.automatic_save'));
      } catch (e) {
        console.log(e)
      }
    }, (1000 * 60 * 2)); // 2 minuty
    */
  },
  created() {

  },
  beforeDestroy() {
    //clearInterval(this.autoSaveInterval);
  }
}
</script>

<style lang="scss">
input[type='number'] {
  text-align: right;
}

.color-blue {
  color: #005A9A;
}

.modal-title {
  font-size: 1.05rem;
}

label {
  line-height: 1.1;
}

</style>
